<script lang="ts">
    import L from "leaflet";
    import { onDestroy } from "svelte";
    import type { ParsedLocationResponse } from "../../../../../GlobalHelper/GoogleMapsHelper";
    import { geolocationParser } from "../../../../../GlobalHelper/GoogleMapsHelper";

    export let address: string = "";
    export let handleLocationResponse: (res: ParsedLocationResponse) => void;

    let marker: any = null;

    let m: any;
    let map: any;
    const initialView = [52.8283, 9.5795];

    $: {
        geocodeAddress(address);
    }

    async function geocodeAddress(address: string) {
        if (address && google) {
            const geocoder: google.maps.Geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address: address }, (results, status) => {
                if (status !== "OK") {
                    console.log(status);
                    return;
                }

                handleLocationResponse(geolocationParser(results[0]));

                if (marker) map.removeLayer(marker);

                marker = L.marker([
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng(),
                ]).addTo(map);

                let latLngs = [marker.getLatLng()];
                let markerBounds = L.latLngBounds(latLngs);

                map.fitBounds(markerBounds);
            });
        }
    }

    function createMap(container) {
        m = L.map(container, { preferCanvas: true }).setView(initialView, 5);
        L.tileLayer(
            "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
            {
                attribution: `&copy;<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>,
	        &copy;<a href="https://carto.com/attributions" target="_blank">CARTO</a>`,
                subdomains: "abcd",
                maxZoom: 14,
            }
        ).addTo(m);

        return m;
    }

    function mapAction(container) {
        map = createMap(container);

        return {
            destroy: () => {
                map.remove();
                map = null;
            },
        };
    }

    onDestroy(() => {
        m.off();
    });
    // L.marker([51.5, -0.09]).addTo(mymap);
</script>

<div class="box">
    <link
        rel="stylesheet"
        href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
        integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
        crossorigin=""
    />
    <div class="map" style="height:100%;width:100%" use:mapAction />
</div>

<style>
    .box {
        height: 100%;
        padding: 0;
    }
    .map {
        padding: 0;
    }
</style>
